var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base_title",class:{
        center: _vm.center,
    },style:(("color:" + (_vm.color ? _vm.color : '')))},[(_vm.icon === 'white')?_c('img',{attrs:{"src":require("../../../assets/base-title-icon-2.png")}}):_c('img',{attrs:{"src":require("../../../assets/base-title-icon.png")}}),_vm._v("\n    "+_vm._s(_vm.title)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-494c7373","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/base/base-title.vue
// module id = null
// module chunks = 